// extracted by mini-css-extract-plugin
export default {"item":"Item_item__5bDSj","photo":"Item_photo__vK4ej","price":"Item_price__3-yFO","form":"Item_form__I7U4G","total":"Item_total__Z25+S"};